module.exports = __webpack_public_path__ + "static/media/action_left.919f7fd1.png";